import { Clickable, FormikField, P, Tooltip } from '@ahmdigital/ui';
import { useFormikContext } from 'formik';

import { RefinePriceSchemaType } from '../../../../../../features/refine-price/schema';
import addNoRebateIncomeTier from '../../../../../../utils/add-no-rebate-income-tier';
import constants from '../../../../../../ahm-constants';
import getIncomeTierOptions, { IncomeType } from '../../../../../../utils/get-income-tier-options';

const { THIRD_PARTY } = constants.URLS;

type IncomeTierFieldProps = {
  showExplainer?: boolean;
  showTooltip?: boolean;
};

const IncomeTierField = ({ showExplainer = true, showTooltip }: IncomeTierFieldProps) => {
  const { values } = useFormikContext<RefinePriceSchemaType>();

  const { incomeType } = values;
  const incomeTierOptions = getIncomeTierOptions({ incomeType: incomeType as IncomeType });

  const allOptions = addNoRebateIncomeTier(incomeTierOptions);

  const explanation = (
    <P variant="small14">
      This is your income for{' '}
      <Clickable to={THIRD_PARTY.ATO_MEDICARE_LEVY_SURCHARGE}>Medicare Levy Surcharge</Clickable> purposes, which is
      different to taxable income.{' '}
    </P>
  );

  return (
    <>
      <FormikField
        label={incomeType === constants.INCOME_TYPE.SINGLE ? 'My annual income' : 'Combined annual income'}
        name="incomeTier"
        size="auto"
        inputVariant={['button', 'fullWidth']}
        type="dropdown"
        options={allOptions}
        tooltip={showTooltip && <Tooltip>{explanation}</Tooltip>}
      />

      {showExplainer && explanation}
    </>
  );
};

export default IncomeTierField;
